import type { CSSProperties } from "react";
import { ToastContainer as ToastifyContainer } from "react-toastify";

import ToastCloseButton from "./toast-close-button";

import { classMerge } from "utilities/css";

const CONTAINER_CLASSES = "w-full max-w-[402px]";
const TOAST_CLASSES = "rounded-lg border-l-8 p-0";
const PROGRESS_BAR_CLASSES = "h-[5px] pt-1 opacity-100 rounded-none bg-none";
const BODY_CLASSES = "items-start pl-2 pr-3 py-4";

const TYPE_CLASSES = {
  error: { toast: "border-critical-500", progressBar: "bg-critical-500/50" },
  info: { toast: "border-blue-500", progressBar: "bg-blue-500/50" },
  success: { toast: "border-success-600", progressBar: "bg-success-600/50" },
  warning: { toast: "border-warning-500", progressBar: "bg-warning-500/50" },
  default: { toast: "border-gray-400", progressBar: "bg-gray-400/50" },
} as const;

const typeClasses = (type?: string) =>
  TYPE_CLASSES[type as keyof typeof TYPE_CLASSES] ?? TYPE_CLASSES.default;

const ToastContainer = () => {
  return (
    <>
      <style>
        {`
        .Toastify__progress-bar--bg {
          background: none;
        }
        .Toastify__toast-icon {
          display: block;
          width: auto;
          margin: 0;

          &>svg {
            width: 1.5rem;
            height: 1.5rem;
          }
        }
      `}
      </style>
      <ToastifyContainer
        autoClose={5000}
        draggable
        position="top-right"
        hideProgressBar={false}
        pauseOnHover
        closeOnClick={false}
        closeButton={(props) => <ToastCloseButton {...props} />}
        className={CONTAINER_CLASSES}
        toastClassName={(context) =>
          classMerge(TOAST_CLASSES, typeClasses(context?.type).toast, context?.defaultClassName)
        }
        bodyClassName={BODY_CLASSES}
        progressClassName={(context) =>
          classMerge(
            PROGRESS_BAR_CLASSES,
            typeClasses(context?.type).progressBar,
            context?.defaultClassName,
          )
        }
        style={
          {
            "--toastify-color-progress-bgo": 1,
          } as CSSProperties
        }
      />
    </>
  );
};

export default ToastContainer;
